import {config as numberColumnConfig} from '../../common/NumberColumn';
import {labels as utilLabels} from '../../../../../../util/utils';

export const prop = 'cRDue5';

export const config = (labels) =>
	numberColumnConfig({
		id: 'comingDue',
		label: labels.comingDue,
		width: 'minmax(var(--px-190), 1fr)',
		prop,
		customHeaderTooltip: utilLabels.next5days
	});
